module.exports = __webpack_public_path__ + "img/high.56ad6ec3.png";